angular
    .module('control.searchDropdown')
    .directive("searchDropdown", ['$timeout', '$parse', 'searchDropdownConst',
        function ($timeout, $parse, searchDropdownConst) {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    placeholder: '@',
                    delayInterval: '=',
                    ngModel: '=',
                    selectedData: '=',
                    rowsPerPage: '=',
                    fnQuery: '&',
                    fnCurrent: '&'
                },
                controller: function ($scope) {
                    $timeout(function () {
                        if (angular.isUndefined($scope.placeholder)) {
                            $scope.placeholder = "Please select";
                        }
                        if (angular.isUndefined($scope.delayInterval)) {
                            $scope.delayInterval = searchDropdownConst.SEARCH_DEPLAY;
                        }
                        $scope.totalItemsFound = 0;
                        $scope.totalItemsShown = 0;
                        $scope.selectedData = null;
                        $scope.currentList = [];
                        $scope.cacheDataSource = [];

                    });
                },
                link: function (scope, element, attrs) {
                    var typingTimer = null;
                    var width = $parse(attrs.width)(scope);

                    $timeout(function () {
                        $.fn.select2.amd.require(['select2/data/array', 'select2/utils'],
                            function (ArrayAdapter, Utils) {
                                function CustomDataAdapter($element, options) {
                                    CustomDataAdapter.__super__.constructor.call(this, $element, options);
                                }

                                Utils.Extend(CustomDataAdapter, ArrayAdapter);

                                var getItems = function (key, callback) {
                                    var cachedData = scope.cacheDataSource[key];

                                    if (cachedData) { // check if data existing in cachedData variable
                                        $timeout(function () {
                                            scope.totalItemsFound = cachedData.totalItems;
                                            scope.totalItemsShown = cachedData.totalItems > scope.rowsPerPage ? scope.rowsPerPage : cachedData.totalItems;
                                        });
                                        scope.currentList = cachedData.results;
                                        clearTimeout(typingTimer);
                                        callback(cachedData);

                                    } else {
                                        if (!typingTimer && !key) {
                                            //first time open dropdownlist, search instantly
                                            scope.fnQuery()(scope, key, callback);

                                        } else {
                                            clearTimeout(typingTimer);
                                            typingTimer = setTimeout(scope.fnQuery(), scope.delayInterval, scope, key, callback);
                                        }
                                    }
                                } // getItems

                                CustomDataAdapter.prototype.query = function (params, callback) {
                                    var key = params.term || '';
                                    getItems(key, callback);
                                }; // query

                                CustomDataAdapter.prototype.current = function (callback) {
                                    scope.fnCurrent()(scope, callback);
                                }; // current

                                var customAdapter = CustomDataAdapter;
                                element.select2({
                                    dataAdapter: customAdapter,
                                    placeholder: scope.placeholder,
                                    width: width,
                                });
                                element.select2Initialized = true;
                            });
                    });

                    //preserve search string
                    $(element).on('select2:closing', function () {
                        $(this).data('kmselect2LastSearch', $('.select2-search__field').val());

                        $timeout(function () {
                            scope.isLoading = false;
                        });
                    });

                    $(element).on('select2:open', function () {
                        $timeout(function () {
                            scope.isLoading = true;
                        });

                        if (typeof $(this).data('kmselect2LastSearch') == 'undefined') {
                            return;
                        }
                        var prevValue = $(this).data('kmselect2LastSearch');
                        if (prevValue != '') {
                            $timeout(function () {
                                $('.select2-search__field').val(prevValue).trigger('keydown').trigger('input');
                            }, 50);

                        }
                    });

                    //clear cache when submit injury success because order now changed
                    scope.$on('clearDropdownCache', function () {
                        scope.cacheDataSource = [];
                    });
                } //link
            }; //return
        }
    ])